import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bba7768"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "goods-item" }
const _hoisted_3 = { class: "img-box" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "goods-title" }
const _hoisted_6 = { class: "goods-price" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-fl-renminbi" }, null, -1))
const _hoisted_8 = { class: "goods-nums" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.loading || _ctx.goodslit.length > 0)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        class: "goods-list",
        style: _normalizeStyle({
      width: _ctx.listwidth + 'px',
    })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodslit, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            onClick: ($event: any) => (_ctx.gotoGoods(item.id))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "goods-img",
                  src: _ctx.getImgUrl(item.photo)
                }, null, 8, _hoisted_4)
              ]),
              _createElementVNode("p", _hoisted_5, _toDisplayString(item.names), 1),
              _createElementVNode("p", _hoisted_6, [
                _hoisted_7,
                _createTextVNode(_toDisplayString(_ctx.showPrice(item.price, 1)), 1)
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(item.click) + "次浏览", 1)
            ])
          ], 8, _hoisted_1))
        }), 256))
      ], 4))
    : _createCommentVNode("", true)
}